// Mock data for Supa Energy Hub

export const companyInfo = {
  brandName: "Supa Energy Hub",
  legalEntity: "Green Circle Solutions Pty Ltd",
  tagline: "Your trusted partner for smarter home energy.",
  motto: "Making Sustainable Living a Reality",
  phone: "0478 453 548",
  email: "hello@supaenergyhub.com.au",
  website: "supaenergyhub.com.au",
  location: "Victoria, Australia",
  logo: "/logo.png"
};

export const services = [
  {
    id: "solar",
    title: "Solar Panel Systems",
    shortDescription: "Harness the power of the sun to generate clean, renewable energy for your home.",
    description: "Our premium solar panel systems are designed for Australian conditions, maximising energy generation while reducing your electricity bills. We only use tier-1 panels backed by comprehensive warranties.",
    icon: "Sun",
    benefits: [
      "Reduce electricity bills by up to 70%",
      "Increase property value",
      "25-year performance warranty",
      "Government rebates available"
    ]
  },
  {
    id: "battery",
    title: "Battery Storage",
    shortDescription: "Store excess solar energy and use it when you need it most.",
    description: "Battery storage systems allow you to store surplus solar energy during the day and use it at night or during peak tariff times, maximising your energy independence.",
    icon: "Battery",
    benefits: [
      "Energy independence",
      "Backup power during outages",
      "Maximise self-consumption",
      "Reduce grid dependency"
    ]
  },
  {
    id: "solar-battery",
    title: "Solar + Battery Bundles",
    shortDescription: "The complete energy solution combining solar generation with smart storage.",
    description: "Our bundled systems offer the best value, combining high-efficiency solar panels with premium battery storage for a complete home energy solution.",
    icon: "Zap",
    benefits: [
      "Best value package pricing",
      "Seamless integration",
      "Single point of contact",
      "Optimised system design"
    ]
  },
  {
    id: "heat-pump",
    title: "Heat Pump Hot Water",
    shortDescription: "Efficient electric hot water that uses up to 75% less energy than traditional systems.",
    description: "Heat pump hot water systems extract heat from the air to warm your water, making them incredibly efficient and perfect for pairing with solar power.",
    icon: "Thermometer",
    benefits: [
      "Up to 75% more efficient",
      "Government rebates available",
      "Eliminate gas bills",
      "Work efficiently in all climates"
    ]
  },
  {
    id: "hvac",
    title: "Heating & Cooling",
    shortDescription: "Energy-efficient split systems and reverse cycle air conditioning for year-round comfort.",
    description: "Modern reverse cycle systems provide efficient heating and cooling, reducing your energy consumption while keeping your home comfortable all year.",
    icon: "Wind",
    benefits: [
      "Year-round comfort",
      "Energy-efficient operation",
      "Quiet performance",
      "Smart controls available"
    ]
  },
  {
    id: "ev-charger",
    title: "EV Chargers",
    shortDescription: "Home charging solutions for your electric vehicle.",
    description: "Charge your electric vehicle at home with our smart EV charging solutions. Integrate with your solar system to charge using clean energy from your roof.",
    icon: "Car",
    benefits: [
      "Convenient home charging",
      "Smart scheduling",
      "Solar integration",
      "Future-proof your home"
    ]
  }
];

export const accreditations = [
  {
    id: "netcc",
    title: "NETCC Approved Seller",
    description: "Compliant with the New Energy Tech Consumer Code, ensuring fair and transparent dealings with customers."
  },
  {
    id: "solar-vic",
    title: "Solar Victoria Approved Retailer",
    description: "Authorised to deliver Solar Victoria rebate programs, ensuring quality and compliance."
  },
  {
    id: "cec",
    title: "CEC Accredited Installers",
    description: "All installations performed by Clean Energy Council accredited installers."
  },
  {
    id: "standards",
    title: "Australian Standards Compliant",
    description: "All systems meet or exceed Australian safety and quality standards."
  }
];

export const howItWorks = [
  {
    step: 1,
    title: "Get in Touch",
    description: "Contact us for a no-obligation consultation. We'll discuss your energy goals and answer any questions."
  },
  {
    step: 2,
    title: "Understand Your Usage",
    description: "We analyse your electricity usage patterns to design a system that meets your specific needs."
  },
  {
    step: 3,
    title: "Personalised Recommendation",
    description: "Receive a tailored solution with clear pricing, expected savings, and available rebates."
  },
  {
    step: 4,
    title: "Professional Installation",
    description: "Our CEC-accredited installers complete your installation to the highest standards."
  },
  {
    step: 5,
    title: "Grid Connection",
    description: "We handle all paperwork and grid connection requirements on your behalf."
  },
  {
    step: 6,
    title: "Ongoing Support",
    description: "Enjoy peace of mind with our local after-sales support and warranty management."
  }
];

export const rebates = [
  {
    id: "stc",
    title: "Small-scale Technology Certificates (STCs)",
    description: "A federal government incentive that provides an upfront discount on your solar system. The value varies based on system size and location.",
    eligibility: "Available to all Australian households installing eligible solar systems."
  },
  {
    id: "solar-vic-rebate",
    title: "Solar Victoria Rebate",
    description: "Victorian households may be eligible for rebates on solar panel systems, solar battery storage, and solar hot water systems.",
    eligibility: "Victorian homeowners meeting income and property requirements."
  },
  {
    id: "interest-free",
    title: "Interest-Free Loans",
    description: "Solar Victoria offers interest-free loans to help spread the cost of your solar or battery system.",
    eligibility: "Victorian households eligible for the Solar Homes Program."
  }
];

export const whyChooseUs = [
  {
    title: "Local Accountability",
    description: "We're an Australian-owned business with local teams who take pride in every installation.",
    icon: "MapPin"
  },
  {
    title: "Transparent Pricing",
    description: "No hidden costs or surprise fees. Clear, upfront pricing on every quote.",
    icon: "FileCheck"
  },
  {
    title: "Quality Products",
    description: "We only use tier-1 components from trusted manufacturers with proven track records.",
    icon: "Award"
  },
  {
    title: "Expert Guidance",
    description: "Our team helps you navigate rebates, grid requirements, and system options.",
    icon: "Users"
  },
  {
    title: "Warranty Support",
    description: "All warranties are honoured and managed locally, giving you peace of mind.",
    icon: "Shield"
  },
  {
    title: "Long-term Partnership",
    description: "We're here for the life of your system, not just the sale.",
    icon: "Handshake"
  }
];

export const testimonials = [
  {
    id: 1,
    name: "Sarah M.",
    location: "Melbourne, VIC",
    text: "The team at Supa Energy Hub made going solar so easy. They explained everything clearly and the installation was completed professionally. Already seeing great savings!",
    rating: 5
  },
  {
    id: 2,
    name: "David K.",
    location: "Geelong, VIC",
    text: "After getting quotes from several companies, Supa Energy Hub stood out for their honest advice. They didn't try to oversell - just recommended what we actually needed.",
    rating: 5
  },
  {
    id: 3,
    name: "Lisa T.",
    location: "Ballarat, VIC",
    text: "Our heat pump hot water system has been fantastic. The installer was knowledgeable and tidy. Love that we're no longer dependent on gas.",
    rating: 5
  }
];

export const faqs = [
  {
    question: "How much can I save with solar?",
    answer: "Savings vary based on your energy usage, system size, and electricity rates. Most households save between 50-70% on their electricity bills. We provide personalised savings estimates based on your actual usage data."
  },
  {
    question: "What rebates am I eligible for?",
    answer: "Most Australian households are eligible for STCs (Small-scale Technology Certificates) which provide an upfront discount. Victorian residents may also qualify for Solar Victoria rebates and interest-free loans. We help you navigate all available incentives."
  },
  {
    question: "How long does installation take?",
    answer: "Most residential solar installations are completed in one day. Battery installations may take an additional day. We'll provide a clear timeline during your consultation."
  },
  {
    question: "What warranties do you offer?",
    answer: "Our systems come with comprehensive warranties: typically 25 years on solar panel performance, 10-15 years on inverters, and 10 years on batteries. We manage all warranty claims locally."
  },
  {
    question: "Do you handle grid connection?",
    answer: "Yes, we manage the entire process including all paperwork, approvals, and coordination with your electricity distributor. You don't need to deal with any of it."
  },
  {
    question: "What makes Supa Energy Hub different?",
    answer: "We focus on education and long-term relationships, not high-pressure sales. As a NETCC Approved Seller and Solar Victoria Approved Retailer, we're held to the highest standards of customer care."
  }
];

export const navLinks = [
  { label: "Home", href: "/" },
  { label: "Services", href: "/services" },
  {
    label: "Products",
    href: "/products/heat-pumps",
    children: [
      { label: "Heat Pumps", href: "/heat-pump" },
      { label: "Home Batteries", href: "/products/batteries" },
      { label: "All Brands", href: "/brands" },
    ],
  },
  { label: "Projects", href: "/projects" },
  {
    label: "Packages",
    href: "/packages",
    children: [
      { label: "All Packages", href: "/packages" },
      { label: "Fox ESS Battery Packages", href: "/fox-ess-battery-packages" },
      { label: "GoodWe Battery Packages", href: "/goodwe-battery-packages" },
      { label: "Deye Battery Packages", href: "/deye-battery-packages" },
    ],
  },
  {
    label: "Rebates",
    href: "/rebates",
    children: [
      { label: "All Rebates", href: "/rebates" },
      { label: "🔥 VIC Deadline · 30 June 2026", href: "/vic-rebate-deadline" },
      { label: "NSW Home Energy Saver", href: "/nsw-home-energy-saver" },
      { label: "🏆 Sports Club Grant (Game On)", href: "/game-on-climate-action" },
    ],
  },
  {
    label: "About",
    href: "/about",
    children: [
      { label: "About Us", href: "/about" },
      { label: "Supa Promise", href: "/supa-promise" },
      { label: "Supa Value Guarantee", href: "/supa-value-guarantee" },
    ],
  },
  { label: "Referral", href: "/referral-program" },
  { label: "Support", href: "/support" },
  { label: "Contact", href: "/contact" }
];
